import { IKnowledgeArea } from '../../interfaces/KnowledgeArea/KnowledgeArea'
import { IOurStudent, IOurStudentFormFields } from '../../interfaces/Testimonials/ITestimonials'
import apiService from '../Api'

export class TestimonialsService {
  async list(params: { search: string; page: number; page_size: number }): Promise<{
    data: IOurStudent[]
    recordsTotal: number
    recordsFiltered: number
  }> {
    return apiService.get('/internal/website/our-students', { params }).then((res) => res.data)
  }

  async listKnowledgeArea(): Promise<IKnowledgeArea[]> {
    return apiService.get('/knowledge-areas').then((res) => res.data.areas)
  }

  async get(id: number): Promise<IOurStudent> {
    return apiService.get(`/internal/website/our-students/${id}`).then((res) => res.data)
  }

  async create(form: IOurStudentFormFields): Promise<IOurStudent> {
    const formData = new FormData()
    formData.append('name', form.name)
    formData.append('knowledge_area_id', String(form.knowledge_area_id))
    formData.append('description', form.description)
    if (form.video) {
      formData.append('video', form.video)
    }
    if (form.image) {
      formData.append('image', form.image)
    }

    return apiService.post('/internal/website/our-students', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }

  async update(id: number, form: IOurStudentFormFields): Promise<IOurStudent> {
    const formData = new FormData()
    formData.append('_method', 'PUT')
    formData.append('name', form.name)
    formData.append('knowledge_area_id', String(form.knowledge_area_id))
    formData.append('description', form.description)
    // Sem arquivo novo o campo nem vai no FormData: a API entende como "mantém o
    // vídeo atual" em vez de limpar.
    if (form.video) {
      formData.append('video', form.video)
    }
    if (form.image) {
      formData.append('image', form.image)
    }

    return apiService.post(`/internal/website/our-students/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/internal/website/our-students/${id}`)
  }
}
